import styles from "./index.module.scss";
import { StyledCheckboxOrRadio } from "components/inputs/checkbox/StyledCheckboxOrRadio";

export const RadioGroup = ({
    selected,
    title,
    onChange,
    options
}: {
    selected: string;
    title: string;
    onChange: (value: string) => void;
    options: {
        id: string;
        label: string | JSX.Element;
    }[];
}) => {
    return (
        <fieldset className={styles["options"]}>
            <legend className={styles["legend-title"]}>{title}</legend>
            {options.map((option) => {
                const isSelected = selected === option.id;
                return (
                    <label
                        key={option.id}
                        htmlFor={`card-${option.id}`}
                        className={styles.card}
                    >
                        {option.label}
                        <StyledCheckboxOrRadio
                            id={`card-${option.id}`}
                            type="radio"
                            checked={isSelected}
                            onChange={() => onChange(option.id)}
                        />
                    </label>
                );
            })}
        </fieldset>
    );
};
